import React, { useState } from 'react';
import { AiOutlineCloudUpload } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { MdDelete } from 'react-icons/md';
import { categories } from '../utils/data';
import { client } from '../client';
import Spinner from './Spinner';

const inputClassNames = "outline-none text-base sm:text-lg border-b-2 border-gray-200 p-2";

export default function CreatePin({ user }) {
  const [title, setTitle] = useState("");
  const [about, setAbout] = useState("");
  const [loading, setLoading] = useState(false);
  const [destination, setDestination] = useState("");
  const [fields, setFields] = useState("");
  const [category, setCategory] = useState(null);
  const [imageAsset, setImageAsset] = useState(null);
  const [wrongImageType, setWrongImageType] = useState(false);
  const navigate = useNavigate();

  const uploadImageHandle = e => {
    const {type,name} = e.target.files[0];

    if (type === 'image/png' || type === 'image/svg' || type === 'image/jpeg' || type === 'image/gif' || type === 'image/tiff') {
      setWrongImageType(false);
      setLoading(true);

      client.assets
        .upload('image', e.target.files[0], { contentType: type, filename: name })
        .then(document => {
          setImageAsset(document);
          setLoading(false);
        })
        .catch(error => console.error('Upload image failed:', error));
    } else {
      setLoading(false);
      setWrongImageType(true);
    }
  };

  const savePinHandle = () => {
    const regexQuery = /^((http(s?)?):\/\/)?([wW]{3}\.)?[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/g;

    if (!title) {
      setFields("Please fill title!");
      setTimeout(() => setFields(""),5000);
    } else if (title.length > 40) {
      setFields("Title must be less than 40 letters!");
      setTimeout(() => setFields(""),5000);
    } else if (!about) {
      setFields("Please fill about!");
      setTimeout(() => setFields(""),5000);
    } else if (about.length > 300) {
      setFields("About must be less than 300 letters!");
      setTimeout(() => setFields(""),5000);
    } else if (!destination) {
      setFields("Please fill destination!");
      setTimeout(() => setFields(""),5000);
    } else if (destination.match(regexQuery) === null) {
      setFields("Destination url is invalid!");
      setTimeout(() => setFields(""),5000);
    } else if (!(destination.startsWith("http"))) {
      setFields("Please write http(s):// for destination url. e.g: https://example.com");
      setTimeout(() => setFields(""),5000);
    } else if (destination.length > 50) {
      setFields("Destination url must be less than 50 letters!");
      setTimeout(() => setFields(""),5000);
    } else if (!category) {
      setFields("Please select category!");
      setTimeout(() => setFields(""),5000);
    } else if (!imageAsset) {
      setFields("Please upload image!");
      setTimeout(() => setFields(""),5000);
    } else {
      const doc = {
        _type: 'pin',
        title,
        about,
        destination,
        image: {
          _type: 'image',
          asset: {
            _type: 'reference',
            _ref: imageAsset?._id,
          },
        },
        userId: user._id,
        postedBy: {
          _type: 'postedBy',
          _ref: user._id,
        },
        category,
      };

      client
        .create(doc)
        .then(() => navigate('/'))
        .catch(e => console.error("Post Pin Error: ",e));
    }
  };

  return (
    <div className="flex flex-col justify-center items-center mt-5 lg:h-4/5">
      {fields && (
        <p className="text-red-500 mb-5 text-xl transition-all duration-150 ease-in ">{fields}</p>
      )}
      <div className=" flex lg:flex-row flex-col justify-center items-center bg-white lg:p-5 p-3 lg:w-4/5  w-full">
        <div className="bg-secondaryColor p-3 flex flex-0.7 w-full">
          <div className=" flex justify-center items-center flex-col border-2 border-dotted border-gray-300 p-3 w-full h-420">
            {loading && <Spinner />}
            {wrongImageType && <p>It&apos;s wrong file type.</p>}
            {!imageAsset ? (
              <label>
                <div className="flex flex-col items-center justify-center h-full">
                  <div className="flex flex-col justify-center items-center">
                    <p className="font-bold text-2xl">
                      <AiOutlineCloudUpload />
                    </p>
                    <p className="text-lg">Click to upload</p>
                  </div>
                  <p className="mt-32 text-gray-400"> Use high-quality JPG, JPEG, SVG, PNG, GIF or TIFF less than 20MB</p>
                </div>
                <input
                  type="file"
                  name="upload-image"
                  onChange={uploadImageHandle}
                  className="w-0 h-0"
                />
              </label>
            ) : (
              <div className="relative h-full">
                <img
                  src={imageAsset?.url}
                  alt="uploaded-pic"
                  className="h-full w-full"
                />
                <button
                  type="button"
                  className="absolute bottom-3 right-3 p-3 rounded-full bg-white text-xl cursor-pointer outline-none hover:shadow-md transition-all duration-500 ease-in-out"
                  onClick={() => setImageAsset(null)}
                >
                  <MdDelete />
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-1 flex-col gap-6 lg:pl-5 mt-5 w-full">
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Add your title"
            className="outline-none text-2xl sm:text-3xl font-bold border-b-2 border-gray-200 p-2"
          />
          {user && (
            <div className="flex gap-2 mt-2 mb-2 items-center bg-white rounded-lg">
              <img
                src={user.image}
                className="w-10 h-10 rounded-full"
                alt="user-profile"
              />
              <p className="font-bold">{user.userName}</p>
            </div>
          )}
          <input
            type="text"
            value={about}
            onChange={e => setAbout(e.target.value)}
            placeholder="Tell everyone what your Pin is about"
            className={inputClassNames}
          />
          <input
            type="url"
            vlaue={destination}
            onChange={e => setDestination(e.target.value)}
            placeholder="Add a destination link e.g: https://example.com"
            className={inputClassNames}
          />
          <div className="flex flex-col">
            <div>
              <p className="mb-2 font-semibold text:lg sm:text-xl">Choose Pin Category</p>
              <select
                onChange={e => setCategory(e.target.value)}
                className="outline-none w-4/5 text-base border-b-2 border-gray-200 p-2 rounded-md cursor-pointer"
              >
                <option value="others" className="sm:text-bg bg-white">Select Category</option>
                {categories.map(({name}) => (
                  <option className="text-base border-0 outline-none capitalize bg-white text-black" value={name} key={name}>
                    {name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex justify-end items-end mt-5">
              <button
                type="button"
                onClick={savePinHandle}
                className="bg-red-500 text-white font-bold p-2 rounded-full w-28 outline-none"
              >
                Save Pin
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};